import { apiAiFrameworkUsage } from '@modules/ai-framework/api/apiAiFrameworkUsage'

// Slice `usage` (spec-004 G14) — sub-módulo namespaced `aiFramework/usage/*`
// (gestor-only). Observabilidade, NÃO billing (RF9.2). Toda action lê `r.status` do BODY.
const STATUS_OK = 200
const STATUS_FORBIDDEN = 403

const state = () => ({
  // Agregado do período: kpis, série temporal e quebra por agente, ou null.
  summary: null,
  loading: false,
  forbidden: false,
  periodo: { de: null, ate: null },
})

const getters = {
  usageSummary: (s) => s.summary,
  usageLoading: (s) => s.loading,
  usageForbidden: (s) => s.forbidden,
  usagePeriodo: (s) => s.periodo || {},
}

const mutations = {
  SET_SUMMARY(s, payload) {
    s.summary = payload || null
  },
  SET_LOADING(s, payload) {
    s.loading = payload
  },
  SET_FORBIDDEN(s, payload) {
    s.forbidden = payload
  },
  SET_PERIODO(s, payload) {
    s.periodo = { ...s.periodo, ...payload }
  },
}

const actions = {
  async fetchUsage({ commit, dispatch }, { de, ate } = {}) {
    commit('SET_PERIODO', { de, ate })
    commit('SET_LOADING', true)

    const r = await apiAiFrameworkUsage.summary({ de, ate })

    if (r && r.status === STATUS_OK) {
      commit('SET_SUMMARY', r.value || null)
      commit('SET_FORBIDDEN', false)
    } else if (r && r.status === STATUS_FORBIDDEN) {
      commit('SET_SUMMARY', null)
      commit('SET_FORBIDDEN', true)
    } else {
      // Inclui o 400 de período inválido: em todos os casos a tela fica sem dados e
      // o snack mostra o TEXTO EXATO do backend — ramo separado só duplicava código.
      commit('SET_SUMMARY', null)
      dispatch('feedback/showSnack', r, { root: true })
    }

    commit('SET_LOADING', false)
    return r
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
